import { parse, parseISO } from "date-fns";

export const formatterDate = (date): Date | undefined => {

	// TODO: пересмотреть условие
	// eslint-disable-next-line no-nested-ternary
	const _date = date ? (date.match(/\d\d.\d\d.\d\d\d\d/) ? parse(date, "dd.MM.yyyy", new Date()) : parseISO(date)) : null;

	return _date || undefined;
};